import { useEffect, useState } from "react";
import ViewTicketDrawer from "./ViewTicketDrawer";

import {
    Row,
    Col,
    Button,
    Table,
    Tag,
    Tooltip,
    Select,
    Input,
    message,Typography
} from "antd";

import type { ColumnsType } from "antd/es/table";

import {
    EyeOutlined,
    ReloadOutlined,
    SearchOutlined,
    
} from "@ant-design/icons";

import { getCategories, getMyTickets } from "./ticketApi";

import "./ViewTable.css";

const { Search } = Input;

interface Ticket {

    ticketId: number;

    title: string;

    ticketType: string;
    category:string;

    environment: string;

    status: string;

    createdOn: string;

}

interface ViewTableProps {
    refreshData: () => void;
    selectedStatus?: string;
    onStatusChange: (status: string | undefined) => void;
}
export const ViewTable = ({
    refreshData,
    selectedStatus,
    onStatusChange,
}: ViewTableProps) => {
    const [loading, setLoading] = useState(false);

    const [ticketData, setTicketData] = useState<Ticket[]>([]);

    const [page, setPage] = useState(0);

    const [size, setSize] = useState(10);

    const [totalElements, setTotalElements] = useState(0);

    const [sortBy, setSortBy] =
        useState("createdOn");

    const [sortDir, setSortDir] =
        useState<"asc" | "desc">("desc");

    const [drawerOpen, setDrawerOpen] =
        useState(false);

    const [selectedTicketId, setSelectedTicketId] =
        useState<number | null>(null);

    const [filters, setFilters] = useState({

        search: "",

        status: undefined as string | undefined,

        category: undefined as string | undefined,

        environment: undefined as string | undefined,

    });

    const updateFilter = (
        key: keyof typeof filters,
        value: string | undefined
    ) => {

        setFilters((prev) => ({

            ...prev,

            [key]: value,

        }));

        setPage(0);

    };

    const loadTickets = async () => {

        try {

            setLoading(true);

            const response = await getMyTickets({

                page,

                size,

                search: filters.search,

                status: filters.status,

                category: filters.category,

                environment: filters.environment,

                sortBy,

                sortDir,

            });

            setTicketData(response.content);
            console.log(response)

            setTotalElements(response.totalElements);

        }

        catch (error) {

            console.error(error);

            message.error("Unable to load tickets");

        }

        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadTickets();

    }, [

        page,

        size,

        sortBy,

        sortDir,

        filters.search,

        filters.status,

        filters.category,

        filters.environment,

    ]);
    /* ----------------------------
   Status Tag
-----------------------------*/
useEffect(() => {
    setFilters((prev) => ({
        ...prev,
        status: selectedStatus,
    }));

    setPage(0);
}, [selectedStatus]);

const getStatusTag = (status: string) => {

    switch (status) {

        case "OPEN":
            return <Tag color="blue">OPEN</Tag>;

        case "IN_PROGRESS":
            return (
                <Tag color="orange">
                    IN PROGRESS
                </Tag>
            );

        case "RESOLVED":
            return (
                <Tag color="green">
                    RESOLVED
                </Tag>
            );

        case "CLOSED":
            return (
                <Tag color="puple">
                    CLOSED
                </Tag>
            );

        default:
            return <Tag>{status}</Tag>;

    }

};
 const [categories, setCategories] = useState([]);

useEffect(() => {
    const loadCategories = async () => {
        try {
            const data = await getCategories();
            setCategories(data);
        } catch (error) {
            console.error("Failed to load categories:", error);
            message.error("Unable to load categories");
        }
    };
    loadCategories();
}, []);

/* ----------------------------
   Table Columns
-----------------------------*/

const columns: ColumnsType<Ticket> = [

    {
        title: "Ticket ID",
        dataIndex: "ticketId",
        width: 120,

        sorter: true,

        sortOrder:
            sortBy === "ticketId"
                ? sortDir === "asc"
                    ? "ascend"
                    : "descend"
                : null,

        render: (value) => (
            <strong>{value}</strong>
        ),
    },

    {
        title: "Title",
        dataIndex: "title",

        sorter: true,

        sortOrder:
            sortBy === "title"
                ? sortDir === "asc"
                    ? "ascend"
                    : "descend"
                : null,

        render: (text: string) => (

            <Tooltip title={text}>

                <div
                    style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        lineHeight: "20px",
                    }}
                >
                    {text}
                </div>

            </Tooltip>

        ),
    },

    {
        title: "Ticket Category",
        dataIndex: "category",
        width: 150,

        sorter: true,

        sortOrder:
            sortBy === "category"
                ? sortDir === "asc"
                    ? "ascend"
                    : "descend"
                : null,
    },

    {
    title: "Environment",
    dataIndex: "environment",
    key: "environment",

    render: (value: string | null) => {

        // Null / empty value
        if (!value || value.trim() === "") {
            return (
                <Typography.Text type="secondary">
                    Not Applicable
                </Typography.Text>
            );
        }

        // Break into new line before "("
        const index = value.indexOf("(");

        if (index !== -1) {

            return (
                <Typography.Text>
                    {value.substring(0, index).trim()}
                    <br />
                    {value.substring(index).trim()}
                </Typography.Text>
            );
        }

        return (
            <Typography.Text>
                {value}
            </Typography.Text>
        );
    },
},

    {
        title: "Status",
        dataIndex: "status",
        width: 150,

        sorter: true,

        sortOrder:
            sortBy === "status"
                ? sortDir === "asc"
                    ? "ascend"
                    : "descend"
                : null,

        render: (status: string) =>
            getStatusTag(
                status === "ASSIGNED"
                    ? "IN_PROGRESS"
                    : status
            ),
    },

    {
        title: "Created On",
        dataIndex: "createdOn",
        width: 150,

        sorter: true,

        sortOrder:
            sortBy === "createdOn"
                ? sortDir === "asc"
                    ? "ascend"
                    : "descend"
                : null,

       render: (value: string) => {
    const date = new Date(value);

    return (
        <Typography.Text>
            {date.toLocaleDateString("en-GB")}
            <br />
            {date.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                
                hour12: true,
            })}
        </Typography.Text>
    );
},
           
    },

    {
        title: "Details",
        width: 90,
        align: "center",

        render: (_, record) => (

            <Tooltip title="View Ticket">

                <Button

                    type="text"

                    shape="circle"

                    icon={<EyeOutlined />}

                    onClick={() => {

                        setSelectedTicketId(
                            record.ticketId
                        );

                        setDrawerOpen(true);

                    }}

                />

            </Tooltip>

        ),
    },

];
return (

    <>

        <Row
            gutter={[16, 16]}
            align="middle"
        >

            {/* Search */}

            <Col
                xs={24}
                sm={24}
                md={8}
                lg={8}
            >

                <Search
                    allowClear
                    size="large"
                    value={filters.search}
                    placeholder="Search by Ticket ID or Title"
                    enterButton={<SearchOutlined />}
                    onChange={(e) =>
                        updateFilter(
                            "search",
                            e.target.value
                        )
                    }
                />

            </Col>

            {/* Status */}

            <Col
                xs={24}
                sm={12}
                md={4}
                lg={4}
            >

                <Select
                    allowClear
                    size="large"
                    style={{
                        width: "100%",
                    }}
                    placeholder="Status"
                    value={filters.status}
                   onChange={(value) => {
        updateFilter("status", value);
        onStatusChange(value);
    }}
                    options={[
                        {
                            label: "Open",
                            value: "OPEN",
                        },
                        {
                            label: "In Progress",
                            value: "IN_PROGRESS",
                        },
                        {
                            label: "Resolved",
                            value: "RESOLVED",
                        },
                        {
                            label: "Closed",
                            value: "CLOSED",
                        },
                    ]}
                />

            </Col>

            {/* Ticket Type */}

            <Col
                xs={24}
                sm={12}
                md={4}
                lg={4}
            >

                <Select
                    allowClear
                    size="large"
                    style={{
                        width: "100%",
                    }}
                    placeholder="Ticket Category"
                    value={filters.category}
                    onChange={(value) =>
                        updateFilter(
                            "category",
                            value
                        )
                    }
                     options={categories.map((category: any) => ({
                    label: category.categoryName,
                    value: category.categoryName,
                }))}
                />

            </Col>

            {/* Environment */}

            <Col
                xs={24}
                sm={12}
                md={4}
                lg={4}
            >

                <Select
                    allowClear
                    size="large"
                    style={{
                        width: "100%",
                    }}
                    placeholder="Environment"
                    value={filters.environment}
                    onChange={(value) =>
                        updateFilter(
                            "environment",
                            value
                        )
                    }
                    options={[
                        {
                            label: "Production (Primary)",
                            value: "PRODUCTION(Primary)",
                        },
                        {
                            label: "Pre-Production (Primary)",
                            value: "PRE_PRODUCTION(Primary)",
                        },
                        {
                            label: "Production (Secondary)",
                            value: "PRODUCTION(Secondary)",
                        },
                        {
                            label: "Pre-Production (Secondary)",
                            value: "PRE_PRODUCTION(Secondary)",
                        },
                        {
                            label: "Staging",
                            value: "STAGING",
                        },
                        {
                            label:"Not Applicable",
                            value:"NOT_APPLICABLE"
                        }

                    ]}
                />

            </Col>

            {/* Reset */}

            <Col
                xs={24}
                sm={12}
                md={4}
                lg={4}
            >

                <Button
                    block
                    size="large"
                    icon={<ReloadOutlined />}
                    onClick={() => {

                        setFilters({

                            search: "",

                            status: undefined,

                            category: undefined,

                            environment: undefined,

                        });

                        setPage(0);

                        setSortBy("createdOn");

                        setSortDir("desc");

                    }}
                >

                    Reset

                </Button>

            </Col>

        </Row>
                <Table<Ticket>

            style={{
                marginTop: 24,
            }}

            rowKey="ticketId"

            bordered={false}

            loading={loading}

            columns={columns}

            dataSource={ticketData}

           rowClassName={(record) => {
        switch (record.status) {
            case "OPEN":
                return "ticket-row-open";

            case "IN_PROGRESS":
                return "ticket-row-in-progress";

            case "RESOLVED":
                return "ticket-row-resolved";

            case "CLOSED":
                return "ticket-row-closed";

            default:
                return "";
        }
    }}

            pagination={{

                current: page + 1,

                pageSize: size,

                total: totalElements,

                showSizeChanger: true,

                showQuickJumper: true,

                pageSizeOptions: ["10", "20", "50"],

                showTotal: (total) =>
                    `Total ${total} Tickets`,

            }}

            onChange={(pagination, _, sorter: any) => {

                /* Pagination */

                if (pagination.current) {

                    setPage(pagination.current - 1);

                }

                if (pagination.pageSize) {

                    setSize(pagination.pageSize);

                }

                /* Sorting */

                if (!Array.isArray(sorter)) {

                    if (sorter.order) {

                        setSortBy(sorter.field);

                        setSortDir(

                            sorter.order === "ascend"
                                ? "asc"
                                : "desc"

                        );

                    }

                    else {

                        setSortBy("createdOn");

                        setSortDir("desc");

                    }

                }

            }}

            locale={{

                emptyText: (

                    <div
                        style={{
                            padding: 40,
                            textAlign: "center",
                        }}
                    >

                        No Tickets Found

                    </div>

                ),

            }}

        />

        <ViewTicketDrawer

            open={drawerOpen}

            ticketId={selectedTicketId}

            onClose={() => {

                setDrawerOpen(false);

                setSelectedTicketId(null);
                 loadTickets();      // refresh table
        refreshData();  

            }}

        />

    </>

);

}
